import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Box } from '../../components/Boneyard';
import ENROLLMENT_PAGE_TRANSLATIONS_QUERY from './taLoginPageTranslations.query.graphql.js';
import {
  withApplicationQuery,
  useTranslations,
} from '../../graphql/components/ApplicationQueryProvider';

const StyledExpando = styled.div`
  width: 100%;
  height: ${props => (props.hasShowItem ? '55px' : '45px')};
  text-align: left;
`;

const propTypes = {
  isExpanded: PropTypes.bool,
  toggleSelected: PropTypes.func,
};

const ExpandoLabel = ({ isExpanded, toggleSelected }) => {
  const {
    travelAgentEnrollmentPage: { moreInfoLabel, lessInfoLabel },
  } = useTranslations();

  return (
    <StyledExpando>
      <Box pl={4}>
        <span
          onClick={toggleSelected}
          isOpen={isExpanded}
          style={{
            textDecoration: 'underline',
            color: 'blue',
          }}
        >
          {!isExpanded ? moreInfoLabel : lessInfoLabel}
        </span>
      </Box>
    </StyledExpando>
  );
};

ExpandoLabel.propTypes = propTypes;

export default withApplicationQuery(
  ENROLLMENT_PAGE_TRANSLATIONS_QUERY,
  ExpandoLabel
);
